import api from './api';

export const getReviews = (courseId, page = 1) => api.get(`/courses/${courseId}/reviews?page=${page}`);
export const submitReview = (courseId, data) => api.post(`/courses/${courseId}/reviews`, data);